// Mock data for 1889 Development landing page

export const mockData = {
  hero: {
    title: "We Build Systems.",
    subtitle: "Infrastructure-first solutions for startups in Norfolk, VA. From security systems to full-stack development.",
    backgroundImage: "https://images.unsplash.com/photo-1558627563-3e383cddc94a",
    logo: "https://customer-assets.emergentagent.com/job_tech-engineers-1/artifacts/4vrz9ajg_1889%20DEV%20LOGO%28Cropped%29.png"
  },
  
  services: [
    {
      title: "On-Site Infrastructure",
      description: "Professional installation of security cameras, servers, switches, and network systems. Built for reliability and scale.",
      icon: "Server",
      features: ["Security Camera Systems", "Server Installation & Configuration", "Network Infrastructure", "Cable Management & Documentation"]
    },
    {
      title: "Systems Engineering",
      description: "Architecture and design of scalable systems. From single-office setups to multi-location deployments.",
      icon: "Wrench",
      features: ["System Architecture", "Infrastructure Design", "Capacity Planning", "Performance Optimization"]
    },
    {
      title: "Full-Stack Development",
      description: "Custom web applications built with modern tech. React, FastAPI, MongoDB—engineered for growth.",
      icon: "Code",
      features: ["Web Applications", "Custom Software", "API Development", "Database Design"]
    },
    {
      title: "Ongoing Management",
      description: "Proactive monitoring, maintenance, and support. Your systems stay operational so you can focus on growth.",
      icon: "Shield",
      features: ["24/7 Monitoring", "System Maintenance", "Security Updates", "Technical Support"]
    }
  ],
  
  why1889: {
    title: "Why 1889",
    content: `The year 1889 marks a turning point in human progress—an era when craftsmanship evolved into engineering, and isolated tools became interconnected systems.

It is the year Nintendo was founded. It is the year the Eiffel Tower was unveiled. More broadly, it represents the moment when industry began to think in terms of infrastructure: scalable, repeatable, reliable systems designed to outlast their creators.

That philosophy is what defines 1889 Development.

We build software the same way great engineers built railways, power grids, and cities—intentionally, structurally, and with longevity in mind. Not quick hacks. Not disposable tools. Real systems that impose order on chaos.

1889 is a reminder that meaningful progress comes from designing things that endure.`
  },
  
  currentProject: {
    name: "Project Chrono",
    tagline: "Next-Generation Competitive Gaming Platform",
    status: "Pre-Alpha",
    description: "A revolutionary gaming platform built for competitive scrimming. Where FaceIt stopped innovating, we're just getting started. Modern infrastructure meets competitive gaming.",
    vision: "Building the competitive gaming infrastructure that the esports community deserves—fast, reliable, and built to scale.",
    features: [
      "Real-time matchmaking system",
      "Advanced statistics & analytics",
      "Tournament infrastructure",
      "Modern, intuitive interface"
    ],
    image: "https://images.unsplash.com/photo-1636489889882-c24c16741cc8"
  },
  
  process: [
    { step: "Discover", description: "Understanding your infrastructure needs" },
    { step: "Design", description: "Architecting scalable solutions" },
    { step: "Build", description: "Engineering with precision" },
    { step: "Refine", description: "Testing and optimization" },
    { step: "Ship", description: "Deployment and ongoing support" }
  ],
  
  founder: {
    title: "Built by a Systems Engineer",
    name: "Founder, 1889 Development",
    bio: "A Systems Engineer by trade, building infrastructure with the same rigor applied to critical systems. Every installation is planned with longevity, scalability, and reliability in mind.",
    philosophy: "Infrastructure should be engineered, not just installed. Systems should endure, not just function.",
    github: "https://github.com/1889-Development",
    location: "Norfolk, VA"
  },
  
  contact: {
    cta: "Let's Build Your Infrastructure",
    description: "Serving startups in the Norfolk, VA area. Whether you need on-site installations or custom software, let's talk about building systems that scale.",
    email: "contact@1889dev.com",
    github: "https://github.com/1889-Development",
    location: "Norfolk, VA"
  }
};
